import { render, staticRenderFns } from "./NodeIcon.vue?vue&type=template&id=1ceb4542&"
import script from "./NodeIcon.vue?vue&type=script&lang=ts&"
export * from "./NodeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports